import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Auth, onAuthStateChanged, type User } from 'firebase/auth';

export function authState$(auth: Auth): Observable<User | null> {
  return new Observable<User | null>(subscriber => {
    const unsubscribe = onAuthStateChanged(
      auth,
      user => subscriber.next(user),
      err => subscriber.error(err),
      () => subscriber.complete()
    );
    return unsubscribe;
  });
}

/**
 * Warm-nav auth check: if Firebase already has a user, allow immediately
 * instead of opening a new `onAuthStateChanged` observer (that callback
 * is async and can stall during token refresh).
 */
export function signedIn$(auth: Auth): Observable<boolean> {
  if (auth.currentUser) {
    return of(true);
  }
  return authState$(auth).pipe(
    take(1),
    map(user => user !== null)
  );
}
